"use strict";
/* eslint-disable no-param-reassign */
Object.defineProperty(exports, "__esModule", { value: true });
exports.solveKnapsackBruteForce = void 0;
const consts_1 = require("../consts");
const error_1 = require("../error");
/**
 * Brute force algorithm utilizing recursive back-tracking to generate power set.
 * Algorithm additionally employs a branch and bound technique to terminate branches
 * once the weight of items in the knapsack exceed the capacity, as addition of more items
 * will always result in an invalid solution.
 *
 * Performance testing of this method should always been done without branch and bound optimization,
 * as worst case performance (2^N time complexity) should dictate the maximum number of items allowed.
 */
const solveKnapsackBruteForce = ({ capacity, knapsackItems, }) => {
    // This implementation is currently limited to 25 items,
    // which worst case takes 2-3 seconds to solve.
    (0, error_1.finleyAssert)(knapsackItems.length <= consts_1.MAX_BRUTE_FORCE_KNAPSACK_ITEM_COUNT, new error_1.FinleyError(`SolveBruteForce is limited to 25 knapsack items. Attempted to solve with ${knapsackItems.length} items.`));
    // Init best result with zero value, and no items in the knapsack
    const bestResult = {
        items: [],
        val: 0,
    };
    const powerSet = ({ index, items, currentItems, currentVal, currentWt, }) => {
        // check to see if items represent a valid solution,
        // if we are already exceeding the capacity, we do not
        // need to continue exploring this branch
        if (currentWt <= capacity) {
            // update best solution if we have a new best
            if (currentVal > bestResult.val) {
                bestResult.items = [...currentItems];
                bestResult.val = currentVal;
            }
            // eslint-disable-next-line no-restricted-syntax
            for (let idx = index; idx < items.length; idx += 1) {
                const item = items[idx];
                currentItems.push(item);
                currentVal += item.val;
                currentWt += item.wt;
                powerSet({
                    index: idx + 1,
                    items,
                    currentItems,
                    currentVal,
                    currentWt,
                });
                currentVal -= item.val;
                currentWt -= item.wt;
                currentItems.pop();
            }
        }
    };
    powerSet({
        index: 0,
        items: knapsackItems,
        currentItems: [],
        currentVal: 0,
        currentWt: 0,
    });
    return bestResult;
};
exports.solveKnapsackBruteForce = solveKnapsackBruteForce;
//# sourceMappingURL=knapsack.js.map